// extracted by mini-css-extract-plugin
export default {"avatar":"ClubJoin--avatar--+N9qG"};